import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

import User from '../views/user/User'
import UserEdit from '../views/user/UserEdit'
import Users from '../views/user/Users'

export default [
  routeWithLayout({ main: Users, path: UrlProvider.getRawUrl('users') }),
  routeWithLayout({ main: User, path: UrlProvider.getRawUrl('user') }),
  routeWithLayout({ main: UserEdit, path: UrlProvider.getRawUrl('user.edit') }),
]
